// SurveyTableSubGrower.jsx
import React, { useState, useEffect } from "react";
import CircularProgress from '@mui/material/CircularProgress';
import IconButton from '@mui/material/IconButton';
import Radio from '@mui/material/Radio';
import "./SurveyTable.css";
import viewEye from "assets/viewEye.svg"
import ConflictModal from "./ConflictModal";
import { formatSurveyDate, equalsIgnoreCase } from "utils/utils";

const SurveyTableSubGrower = ({
    isGlobalProfile,
    isApprover,
    data,
    onAssignmentUpdate,
    selectedStatusPickList,
    selectedForReopen,
    selectedForApprove,
    isVisitCompliance,
    onViewSurvey,
    onBulkActionChange,
    read_only_user
}) => {
    const [loading, setLoading] = useState(false);
    const [bulkReopen, setBulkReopen] = useState(false);
    const [bulkApprove, setBulkApprove] = useState(false);
    const [conflictModalOpen, setConflictModalOpen] = useState(false);
    const [conflictMessage, setConflictMessage] = useState('');

    const isBulkActionsEnabled = () => {
        return selectedStatusPickList?.length === 1 &&
            equalsIgnoreCase(selectedStatusPickList[0]?.pickListDescription, "Completed");
    };

    useEffect(() => {
    }, [bulkReopen, bulkApprove]);

    const handleBulkReopenChange = () => {
        if (!isBulkActionsEnabled()) {
            setConflictMessage(`Please select the completed status in the filter first before selecting Bulk select`)
            setConflictModalOpen(true);
            return
        };
        const newState = !bulkReopen;
        if (newState == true && selectedForApprove?.size > 0) {
            setConflictMessage(`You cannot select both 'Reopen' and 'Approve' for the same Sub Grower. Values selected for 'Approve' will remain selected during bulk 'Reopen' selection. Please manually approve the surveys selected as 'Approve' or manually unselect the 'Approve' surveys for later select bulk 'Reopen'.`);
            setConflictModalOpen(true);
            return;
        }
        setBulkReopen(newState);
        setBulkApprove(false);
        onBulkActionChange?.({ bulkReopen: newState, bulkApprove: false });

        data?.forEach(item => {
            if (item.status === 'Completed') {
                const updatedItem = {
                    ...item,
                    isReopen: false,
                    isApproved: false
                };
                if (newState) {
                    updatedItem.isReopen = true;
                }

                onAssignmentUpdate(updatedItem, 'bulk');
            }
        });
    };

    const handleBulkApproveChange = () => {
        if (!isBulkActionsEnabled()) {
            setConflictMessage(`Please select the completed status in the filter first before selecting Bulk select`)
            setConflictModalOpen(true);
            return
        };
        const newState = !bulkApprove;
        if (newState == true && selectedForReopen?.size > 0) {
            setConflictMessage(`You cannot select both 'Approve' and 'Reopen' for the same Sub Grower and crop stage. Values selected for 'Reopen' will remain selected during bulk 'Approve' selection. Please manually reopen the surveys selected as 'Reopen' or manually unselect the 'Reopen' surveys for later select bulk 'Approve'.`);
            setConflictModalOpen(true);
            return;
        }
        setBulkApprove(newState);
        setBulkReopen(false);
        onBulkActionChange?.({ bulkReopen: false, bulkApprove: newState });

        data?.forEach(item => {
            if (item.status === 'Completed') {
                const updatedItem = {
                    ...item,
                    isApproved: false,
                    isReopen: false
                };
                if (newState) {
                    updatedItem.isApproved = true;
                }
                onAssignmentUpdate(updatedItem, 'bulk');
            }
        });
    };

    const handleView = (item) => {
        onViewSurvey(item);
    };

    const handleReopenChange = (event, item) => {
        if (item.status !== 'Completed') return;

        if (onAssignmentUpdate) {
            const updatedItem = {
                ...item,
                isReopen: event.target.checked,
                isApproved: false
            };
            onAssignmentUpdate(updatedItem, 'individual');
        }
    };

    const handleApproveChange = (event, item) => {
        if (item.status !== 'Completed') return;

        if (onAssignmentUpdate) {
            const updatedItem = {
                ...item,
                isApproved: event.target.checked,
                isReopen: false
            };
            onAssignmentUpdate(updatedItem, 'individual');
        }
    };

    const isRadioDisabled = (item) => {
        return item.status !== 'Completed'
            ||
            !isApprover ||
            isGlobalProfile ||
            isVisitCompliance;
    };

    return (
        <div className="table-container" style={{ paddingTop: '20px' }}>
            <table className={`custom-table sub-grower-table ${isGlobalProfile ? "sub-grower-table-global" : ""}`}>
                <thead>
                    <tr>
                        <th>
                            <span>Property No.</span>
                        </th>
                        <th>
                            <span>Grower No.</span>
                        </th>
                        <th>
                            <span>Sub Grower Code</span>
                        </th>
                        {!isGlobalProfile && (
                            <th>
                                <span>Farmer Name</span>
                            </th>
                        )}
                        {!isGlobalProfile && (
                            <th>
                                <span>Sub Grower Name</span>
                            </th>
                        )}
                        <th>
                            <span>Survey Date</span>
                        </th>
                        <th>
                            <span>Status</span>
                        </th>
                        <th>
                            <span>Approver Name</span>
                        </th>
                        <th>
                            <span>Approved Date</span>
                        </th>

                        <th>
                            <div style={{ display: 'flex', justifyContent: 'flex-start', width: '100%', alignItems: 'center' }}>
                                <Radio
                                    checked={bulkReopen}
                                    onClick={handleBulkReopenChange}
                                    disabled={read_only_user || data?.length === 0 || !isApprover || isGlobalProfile || isVisitCompliance}
                                    sx={{
                                        '& .MuiSvgIcon-root': {
                                            padding: 0,
                                            margin: 0,
                                        },
                                    }}
                                />
                                <span>Reopen</span>
                            </div>
                        </th>
                        <th>
                            <div style={{ display: 'flex', justifyContent: 'flex-start', width: '100%', alignItems: 'center' }}>
                                <Radio
                                    checked={bulkApprove}
                                    onClick={handleBulkApproveChange}
                                    disabled={read_only_user || data?.length === 0 || !isApprover || isGlobalProfile || isVisitCompliance}
                                    sx={{
                                        '& .MuiSvgIcon-root': {
                                            padding: 0,
                                            margin: 0,
                                        },
                                    }}
                                />
                                <span>Approve</span>
                            </div>
                        </th>
                        <th>
                            <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                <span>View Survey</span>
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {data?.map((item, index) => (
                        <tr key={item?.headerId || index}>
                            <td><span className="truncate-cell" title={item?.propertyFarmNo}>{item?.propertyFarmNo}</span></td>
                            <td><span className="truncate-cell" title={item?.allGrowerNos}>{item?.allGrowerNos}</span></td>
                            <td><span className="truncate-cell" title={item?.permanentCode || item?.temporaryCode}>{item?.permanentCode || item?.temporaryCode}</span></td>
                            {!isGlobalProfile && (
                                <td><span className="truncate-cell" title={item?.allFarmerNames}>{item?.allFarmerNames}</span></td>
                            )}
                            {!isGlobalProfile && (
                                <td><span className="truncate-cell" title={item?.subGrowerName}>{item?.subGrowerName}</span></td>
                            )}
                            <td>{formatSurveyDate(item?.surveyDate)}</td>

                            <td>
                                <span
                                    className="truncate-cell"
                                    title={item?.status}
                                    style={{ color: item?.status?.toLowerCase() === 'completed' ? '#004F9F' : 'inherit' }}
                                >
                                    {item?.status}
                                </span>
                            </td>
                            <td><span className="truncate-cell" title={item?.approverName}>{item?.approverName}</span></td>
                            <td>{formatSurveyDate(item?.approvedDate)}</td>

                            <td style={{ justifyContent: 'center' }}>
                                <Radio
                                    checked={item?.status?.toLowerCase() == 're-opened' || Boolean(item?.isReopen)}
                                    onClick={(e) => handleReopenChange(e, item)}
                                    disabled={read_only_user || isRadioDisabled(item) || bulkApprove}
                                    sx={{
                                        '& .MuiSvgIcon-root': {
                                            padding: 0,
                                            margin: 0,
                                        },
                                    }}
                                />
                            </td>
                            <td style={{ justifyContent: 'center' }}>
                                <Radio
                                    checked={item?.status?.toLowerCase() == 'approved' || Boolean(item?.isApproved)}
                                    onClick={(e) => handleApproveChange(e, item)}
                                    disabled={read_only_user || isRadioDisabled(item) || bulkReopen}
                                    sx={{
                                        '& .MuiSvgIcon-root': {
                                            padding: 0,
                                            margin: 0,
                                        },
                                    }}
                                />
                            </td>
                            <td style={{ justifyContent: 'center' }}>
                                <IconButton
                                    size="small"
                                    onClick={() => handleView(item)}
                                    title="View Survey"
                                >
                                    <img src={viewEye} alt="View" style={{ width: 20, height: 20 }} />
                                </IconButton>
                            </td>
                        </tr>
                    ))}
                    {data?.length === 0 && (
                        <tr>
                            {/* CSS Grid ignores colSpan - gridColumn is what actually spans the row here. */}
                            <td colSpan={isGlobalProfile ? 10 : 12} style={{ textAlign: 'center', gridColumn: '1 / -1' }}>
                                No data available
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
            {loading && (
                <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: 'rgba(255, 255, 255, 0.7)'
                }}>
                    <CircularProgress />
                </div>
            )}
            <ConflictModal
                open={conflictModalOpen}
                onClose={() => setConflictModalOpen(false)}
                message={conflictMessage}
            />
        </div>
    );
};

export default SurveyTableSubGrower;
